import type { RouteRecordRaw } from "vue-router"

export const LegacyUserRoutesDefinitions = {
  SETTINGS: { name: "legacy-user/settings" },
  SETTINGS_DETAILS: { name: "legacy-user/settings/details" },
  SETTINGS_ORDERS: { name: "legacy-user/settings/orders" },
  SETTINGS_ORDERS_DETAILS: { name: "legacy-user/settings/orders-details" },
  SETTINGS_RETIREMENTS: { name: "legacy-user/settings/retirements" },
  SETTINGS_DUE_DILIGENCE_REPORTS: { name: "legacy-user/settings/due-diligence-reports" },
} as const

export const legacyUserRoutes: RouteRecordRaw[] = [
  {
    path: "/user/settings",
    name: LegacyUserRoutesDefinitions.SETTINGS.name,
    component: () => import("./views/ViewUser.vue"),
    redirect: LegacyUserRoutesDefinitions.SETTINGS_DETAILS,
    children: [
      {
        path: "details",
        name: LegacyUserRoutesDefinitions.SETTINGS_DETAILS.name,
        component: () => import("./views/ViewUserSettingsDetails.vue"),
      },
      {
        path: "orders",
        children: [
          {
            path: "",
            name: LegacyUserRoutesDefinitions.SETTINGS_ORDERS.name,
            component: () => import("./views/ViewUserSettingsOrders.vue"),
          },
          {
            path: ":id",
            name: LegacyUserRoutesDefinitions.SETTINGS_ORDERS_DETAILS.name,
            component: () => import("./views/ViewUserSettingsOrdersDetails.vue"),
            props: true,
          },
        ],
      },
      {
        path: "retirements",
        name: LegacyUserRoutesDefinitions.SETTINGS_RETIREMENTS.name,
        component: () => import("./views/ViewUserSettingsRetirements.vue"),
      },
      {
        path: "due-diligence-reports",
        name: LegacyUserRoutesDefinitions.SETTINGS_DUE_DILIGENCE_REPORTS.name,
        component: () => import("./views/ViewUserSettingsDdReports.vue"),
      },
    ],
  },
]
